import type IProduct from "@api/models/IProduct";
import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import SSHeadLineHeader from "@core-components/title/components/SSHeadLineHeader";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";

interface ProductDetailsHeroProps {
  product?: IProduct;
}

export const ProductDetailsHero = ({ product }: ProductDetailsHeroProps) => {
  const { t } = useAppTranslation("components.productDetails");
  const productT = useAppTranslation();

  return (
    <SSBackgroundImage>
      <SSBgImageHeadline
        header={<SSHeadLineHeader>{t("header.title")}</SSHeadLineHeader>}
      >
        <SSWhiteText>{t("header.subtitle")}</SSWhiteText>&nbsp;
        <br />
        <SSLoLGradientText>
          {product && productT.t(`${product.i18nKey}.tagline`)}
        </SSLoLGradientText>
      </SSBgImageHeadline>
    </SSBackgroundImage>
  );
};
